import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { cleanTermContent } from "../../libs/term/term";

import {
  GetPublicTermsResponse,
  PublicTermPurpose,
  getPublicTerms,
} from "../../services/etcServices";

type Props = {};

export default function OpenTerm(props: Props) {
  const params = useParams();
  const [term, setTerm] = useState<GetPublicTermsResponse>();

  useEffect(() => {
    const { purpose } = params;
    if (purpose) {
      getPublicTerms(purpose as PublicTermPurpose).then((res) => {
        setTerm(res.data);
      });
    }
  }, []);

  return (
    <div>
      {term?.content && (
        <div
          className=""
          dangerouslySetInnerHTML={{
            __html: cleanTermContent(term?.content as string) || "&nbsp;",
          }}
        />
      )}
    </div>
  );
}
